import { render, staticRenderFns } from "./ServiceUpgradeDialog.vue?vue&type=template&id=2fb2bd32&scoped=true&"
import script from "./ServiceUpgradeDialog.vue?vue&type=script&lang=js&"
export * from "./ServiceUpgradeDialog.vue?vue&type=script&lang=js&"
import style0 from "./ServiceUpgradeDialog.vue?vue&type=style&index=0&id=2fb2bd32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2bd32",
  null
  
)

export default component.exports